import { createFileRoute } from '@tanstack/react-router';

import { MailComposer } from './-components/composer/mail-composer';

export const Route = createFileRoute('/_dashboard/mail/new-message')({
  component: NewMailRoute,
});

function NewMailRoute() {
  return (
    <div className="h-full min-w-0 overflow-auto bg-background">
      <MailComposer mode="new" />
    </div>
  );
}
